<template>
  <div>
    <Breadcrumbs :items="breadcrumbs" page_title="dsdtrainingattendance" />
    <v-container>
      <v-card>
        <v-row justify="space-between" class="ma-1 pa-2">
          <v-col cols="12" xs="12" sm="4" xl="3">
            <v-text-field
              outlined
              dense
              hide-details
              style="border-radius: 8px; border-color: #c0c0c0"
              clearable
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('search')"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            xs="12"
            sm="8"
            xl="9"
            style="text-align: right !important"
          >
            <v-btn
              outlined
              data-testid="dsd-export-btn"
              :disabled="loading || exporting || !hasAnyData"
              :loading="exporting"
              @click="exportExcel"
              style="
                color: #a6cc39;
                font-size: 16px;
                border: 1px solid #c0c0c0;
                box-shadow: unset !important;
                border-radius: 8px;
                background: #ffffff 0% 0% no-repeat padding-box;
              "
              class="text-capitalize"
            >
              <v-icon class="mr-2 mb-1">mdi-export-variant</v-icon>
              {{ $t("exportexcel") }}
            </v-btn>
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-row class="ma-1 px-2">
          <v-col cols="12" xs="12" sm="6" md="3">
            <label class="filter-label">{{ $t("startdate") }}</label>
            <v-menu
              v-model="fromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFrom"
                  data-testid="dsd-date-from"
                  prepend-inner-icon="mdi-calendar-blank-outline"
                  outlined
                  dense
                  readonly
                  hide-details
                  placeholder="yyyy-mm-dd"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateFrom"
                :max="dateTo"
                @input="onFromChange"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3">
            <label class="filter-label">{{ $t("enddate") }}</label>
            <v-menu
              v-model="toMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateTo"
                  data-testid="dsd-date-to"
                  prepend-inner-icon="mdi-calendar-blank-outline"
                  outlined
                  dense
                  readonly
                  hide-details
                  placeholder="yyyy-mm-dd"
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateTo"
                :min="dateFrom"
                :max="today"
                @input="onToChange"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3">
            <label class="filter-label">{{ $t("coursename") }}</label>
            <v-autocomplete
              v-model="selectedCourses"
              :items="courseItems"
              item-text="courseName"
              item-value="courseID"
              multiple
              outlined
              dense
              hide-details
              clearable
              :placeholder="$t('all')"
              data-testid="dsd-course-select"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" small>
                  <span>{{ item.courseName }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption"
                  >(+{{ selectedCourses.length - 1 }})</span
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" xs="12" sm="6" md="3">
            <label class="filter-label">{{ $t("fullnamesm") }}</label>
            <v-autocomplete
              v-model="selectedUsers"
              :items="userItems"
              item-text="fullName"
              item-value="userID"
              multiple
              outlined
              dense
              hide-details
              clearable
              :placeholder="$t('all')"
              data-testid="dsd-user-select"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0" small>
                  <span>{{ item.fullName }}</span>
                </v-chip>
                <span v-if="index === 1" class="grey--text text-caption"
                  >(+{{ selectedUsers.length - 1 }})</span
                >
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row class="ma-1 px-2" justify="end">
          <v-col cols="12" class="d-flex justify-end flex-wrap">
            <v-btn
              text
              class="text-capitalize"
              height="40"
              style="
                border: 1px solid #c0c0c0;
                border-radius: 8px;
                color: #424242;
                font-size: 16px;
              "
              @click="clearAll()"
              >{{ $t("clearall") }}</v-btn
            >
            <v-btn
              width="120"
              height="40"
              class="text-capitalize btn_hover_effect ml-5"
              style="
                color: #ffff;
                border: 1px solid #a6cc39;
                border-radius: 8px;
                font-size: 16px;
              "
              color="#A6CC39"
              data-testid="dsd-search-btn"
              :loading="loading"
              :disabled="loading"
              @click="searchReport()"
              >{{ $t("search") }}</v-btn
            >
          </v-col>
        </v-row>
        <div class="px-5 caption grey--text">{{ $t("dsdtimezonenote") }}</div>

        <v-alert
          v-if="alert"
          dense
          outlined
          :type="alert.type"
          class="mx-5 mt-3"
          >{{ alert.text }}</v-alert
        >

        <v-tabs v-model="tab" color="secondary" show-arrows class="px-5 mt-3">
          <v-tabs-slider></v-tabs-slider>
          <!-- TC-LMS-010/012: สรุปรายหลักสูตรเป็นแท็บแรก -->
          <v-tab class="text-capitalize" data-testid="dsd-tab-summary">{{
            tabLabels[0]
          }}</v-tab>
          <v-tab class="text-capitalize" data-testid="dsd-tab-view">{{
            tabLabels[1]
          }}</v-tab>
          <v-tab class="text-capitalize" data-testid="dsd-tab-login">{{
            tabLabels[2]
          }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- แท็บ 1: สรุปรายหลักสูตร (1 แถว = ผู้เรียน 1 คน × หลักสูตร 1 หลักสูตร) -->
          <v-tab-item>
            <div class="px-5">
              <v-data-table
                class="pt-6 report-table"
                hide-default-footer
                :headers="summaryHeaders"
                :items="courseSummary"
                :search="search"
                :page.sync="pager.summary.page"
                :items-per-page="pager.summary.itemsPerPage"
                @page-count="pager.summary.pageCount = $event"
                :loading="loading"
                :loading-text="$t('dsdloading')"
                :no-results-text="$t('nodata')"
              >
                <template v-slot:no-data>{{ $t("nodata") }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.empID="{ item }">{{
                  dash(item.empID)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.fullName="{ item }">{{
                  dash(item.fullName)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.courseName="{ item }">{{
                  dash(item.courseName)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.courseSeconds="{ item }">{{
                  dash(item.courseHHmm)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.videoCompletedCount="{ item }">{{
                  videoProgressText(item)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.countedSeconds="{ item }">{{
                  dash(item.countedHHmm)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.allTimeCountedSeconds="{ item }">{{
                  dash(item.allTimeCountedHHmm)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.firstWatch="{ item }">{{
                  dash(item.firstWatch)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.lastWatch="{ item }">{{
                  dash(item.lastWatch)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.hasLegacyRows="{ item }">{{
                  summaryNoteText(item) || ""
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.actions="{ item }">
                  <v-btn
                    text
                    small
                    color="secondary"
                    class="text-capitalize px-1"
                    data-testid="dsd-view-detail-btn"
                    @click="showDetail(item)"
                    >{{ $t("dsdviewdetail") }}</v-btn
                  >
                </template>
              </v-data-table>
              <p class="caption grey--text mt-2 mb-0">
                * {{ $t("dsdcountednote") }}
              </p>
            </div>
            <v-row class="ma-1">
              <v-col cols="12" xs="12" sm="9" md="10">
                <div class="d-flex text-left">
                  <v-pagination
                    circle
                    v-model="pager.summary.page"
                    class="pagination"
                    :total-visible="7"
                    :length="pager.summary.pageCount"
                  ></v-pagination>
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="3" md="2" class="d-flex justify-end">
                <p class="mt-3 pr-4">{{ $t("Show") }}</p>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      width="70"
                      v-bind="attrs"
                      v-on="on"
                      style="border: 1px solid #c0c0c0; opacity: 1"
                      class="text-capitalize mt-1"
                      outlined
                    >
                      {{ pager.summary.itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in paginationCount"
                      :key="index"
                      @click="setItemsPerPage('summary', item.title)"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- แท็บ 2: รายละเอียดการชมแต่ละครั้ง (เกณฑ์ข้อ 6.1) -->
          <v-tab-item>
            <div class="px-5">
              <v-chip
                v-if="detailFilter"
                close
                outlined
                color="secondary"
                class="mt-4"
                data-testid="dsd-detail-filter-chip"
                @click:close="clearDetailFilter"
                >{{
                  $t("dsdfilteredby", {
                    name: dash(detailFilter.fullName),
                    course: dash(detailFilter.courseName),
                  })
                }}</v-chip
              >
              <v-data-table
                class="pt-6 report-table"
                hide-default-footer
                :headers="viewHeaders"
                :items="viewSessionsShown"
                :search="search"
                :page.sync="pager.view.page"
                :items-per-page="pager.view.itemsPerPage"
                @page-count="pager.view.pageCount = $event"
                :loading="loading"
                :loading-text="$t('dsdloading')"
                :no-results-text="$t('nodata')"
              >
                <template v-slot:no-data>{{ $t("nodata") }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.empID="{ item }">{{
                  dash(item.empID)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.fullName="{ item }"
                  >{{ dash(item.fullName)
                  }}<span v-if="item.userActive === false" class="grey--text">
                    {{ $t("dsdinactive") }}</span
                  ></template
                >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.courseName="{ item }"
                  >{{ dash(item.courseName)
                  }}<span v-if="item.courseActive === false" class="grey--text">
                    {{ $t("dsdinactive") }}</span
                  ></template
                >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.videoName="{ item }"
                  >{{ dash(item.videoName)
                  }}<span v-if="item.videoActive === false" class="grey--text">
                    {{ $t("dsdinactive") }}</span
                  ></template
                >
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.watchStartUtc="{ item }">{{
                  dash(item.watchStart)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.watchEndUtc="{ item }">{{
                  dash(item.watchEnd)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.watchMinutes="{ item }">{{
                  fmt2(item.watchMinutes)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.loginAt="{ item }">{{
                  dash(item.loginAt)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.logoutAt="{ item }">{{
                  dash(item.logoutAt)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.logoutReason="{ item }">{{
                  dash(reasonText(item.logoutReason))
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.recordType="{ item }">{{
                  recordTypeText(item.recordType) || ""
                }}</template>
              </v-data-table>
              <p v-if="hasLegacyView" class="caption grey--text mt-2 mb-0">
                * {{ $t("dsdlegacynote") }}
              </p>
            </div>
            <v-row class="ma-1">
              <v-col cols="12" xs="12" sm="9" md="10">
                <div class="d-flex text-left">
                  <v-pagination
                    circle
                    v-model="pager.view.page"
                    class="pagination"
                    :total-visible="7"
                    :length="pager.view.pageCount"
                  ></v-pagination>
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="3" md="2" class="d-flex justify-end">
                <p class="mt-3 pr-4">{{ $t("Show") }}</p>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      width="70"
                      v-bind="attrs"
                      v-on="on"
                      style="border: 1px solid #c0c0c0; opacity: 1"
                      class="text-capitalize mt-1"
                      outlined
                    >
                      {{ pager.view.itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in paginationCount"
                      :key="index"
                      @click="setItemsPerPage('view', item.title)"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-tab-item>

          <!-- แท็บ 3: ประวัติเข้า-ออกระบบ -->
          <v-tab-item>
            <div class="px-5">
              <v-data-table
                class="pt-6 report-table"
                hide-default-footer
                :headers="loginHeaders"
                :items="loginSessions"
                :search="search"
                :page.sync="pager.login.page"
                :items-per-page="pager.login.itemsPerPage"
                @page-count="pager.login.pageCount = $event"
                :loading="loading"
                :loading-text="$t('dsdloading')"
                :no-results-text="$t('nodata')"
              >
                <template v-slot:no-data>{{ $t("nodata") }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.empID="{ item }">{{
                  dash(item.empID)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.fullName="{ item }">{{
                  dash(item.fullName)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.platform="{ item }">{{
                  dash(platformText(item.platform))
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.loginAt="{ item }">{{
                  dash(item.loginAt)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.logoutAt="{ item }">{{
                  dash(item.logoutAt)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.durationMinutes="{ item }">{{
                  fmt2(item.durationMinutes)
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.logoutReason="{ item }">{{
                  dash(reasonText(item.logoutReason))
                }}</template>
                <!-- eslint-disable-next-line vue/valid-v-slot -->
                <template v-slot:item.startType="{ item }">{{
                  loginNoteText(item) || ""
                }}</template>
              </v-data-table>
            </div>
            <v-row class="ma-1">
              <v-col cols="12" xs="12" sm="9" md="10">
                <div class="d-flex text-left">
                  <v-pagination
                    circle
                    v-model="pager.login.page"
                    class="pagination"
                    :total-visible="7"
                    :length="pager.login.pageCount"
                  ></v-pagination>
                </div>
              </v-col>
              <v-col cols="12" xs="12" sm="3" md="2" class="d-flex justify-end">
                <p class="mt-3 pr-4">{{ $t("Show") }}</p>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      width="70"
                      v-bind="attrs"
                      v-on="on"
                      style="border: 1px solid #c0c0c0; opacity: 1"
                      class="text-capitalize mt-1"
                      outlined
                    >
                      {{ pager.login.itemsPerPage }}
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in paginationCount"
                      :key="index"
                      @click="setItemsPerPage('login', item.title)"
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </div>
</template>

<script>
// F06 DSD — รายงานการเข้าอบรมรายบุคคล (DSD-01 ข้อ 6.1 / 6.2)
import moment from "moment";
import exceljs from "exceljs";
import { saveAs } from "file-saver";

// ช่วงวันที่สูงสุด (นับรวมวันแรกและวันสุดท้าย — สูตรเดียวกับ API)
const MAX_RANGE_DAYS = 731;

const REASON_KEYS = {
  manual: "dsdreasonmanual",
  timeout: "dsdreasontimeout",
  forced: "dsdreasonforced",
  noLogout: "dsdreasonnologout",
  online: "dsdreasononline",
};

const THIN_BORDER = {
  top: { style: "thin" },
  left: { style: "thin" },
  bottom: { style: "thin" },
  right: { style: "thin" },
};

function nz(v) {
  return v == null || v === "" ? null : v;
}

function num(v) {
  return v == null || v === "" || isNaN(Number(v)) ? null : Number(v);
}

function toDMY(s) {
  return moment(s, "YYYY-MM-DD").format("DD/MM/YYYY");
}

function newPager() {
  return { page: 1, pageCount: 0, itemsPerPage: 20 };
}

export default {
  name: "DsdTrainingAttendance",
  data() {
    return {
      breadcrumbs: [
        {
          sidebar_tilte: "report",
        },
        {
          text: "dsdtrainingattendance",
        },
      ],
      search: "",
      dateFrom: moment().startOf("month").format("YYYY-MM-DD"),
      dateTo: moment().format("YYYY-MM-DD"),
      today: moment().format("YYYY-MM-DD"),
      fromMenu: false,
      toMenu: false,
      courseItems: [],
      userItems: [],
      selectedCourses: [],
      selectedUsers: [],
      loading: false,
      exporting: false,
      alert: null,
      tab: 0,
      viewSessions: [],
      courseSummary: [],
      loginSessions: [],
      detailFilter: null, // { userID, assignmentCourseID, fullName, courseName } จากปุ่ม "ดูรายละเอียด"
      lastQuery: null,
      pager: {
        view: newPager(),
        summary: newPager(),
        login: newPager(),
      },
      paginationCount: [{ title: 10 }, { title: 20 }, { title: 30 }],
    };
  },
  computed: {
    viewHeaders() {
      return [
        this.col("employeeId", "empID"),
        this.col("fullnamesm", "fullName"),
        this.col("coursename", "courseName"),
        this.col("dsdvideoname", "videoName"),
        this.dateCol("dsdwatchstart", "watchStartUtc"),
        this.dateCol("dsdwatchend", "watchEndUtc"),
        this.col("dsdwatchminutes", "watchMinutes"),
        this.dateCol("dsdloginat", "loginAt", false),
        this.dateCol("dsdlogoutat", "logoutAt", false),
        this.col("dsdlogoutreason", "logoutReason"),
        this.col("dsdnote", "recordType"),
      ];
    },
    summaryHeaders() {
      return [
        this.col("employeeId", "empID"),
        this.col("fullnamesm", "fullName"),
        this.col("coursename", "courseName"),
        this.col("dsdcoursehours", "courseSeconds"),
        this.col("dsdvideoscompleted", "videoCompletedCount"),
        this.col("dsdtotalhoursinrange", "countedSeconds"),
        this.col("dsdtotalhoursall", "allTimeCountedSeconds"),
        this.dateCol("dsdfirstwatch", "firstWatch", false),
        this.dateCol("dsdlastwatch", "lastWatch", false),
        this.col("dsdnote", "hasLegacyRows"),
        { text: "", value: "actions", sortable: false, align: "left" },
      ];
    },
    loginHeaders() {
      return [
        this.col("employeeId", "empID"),
        this.col("fullnamesm", "fullName"),
        this.col("dsdplatform", "platform"),
        this.dateCol("dsdloginat", "loginAt", false),
        this.dateCol("dsdlogoutat", "logoutAt", false),
        this.col("dsddurationminutes", "durationMinutes"),
        this.col("dsdlogoutreason", "logoutReason"),
        this.col("dsdnote", "startType"),
      ];
    },
    hasAnyData() {
      return (
        this.viewSessions.length +
          this.courseSummary.length +
          this.loginSessions.length >
        0
      );
    },
    viewSessionsShown() {
      const f = this.detailFilter;
      if (!f) return this.viewSessions;
      return this.viewSessions.filter(
        (r) =>
          r.userID === f.userID && r.assignmentCourseID === f.assignmentCourseID
      );
    },
    hasLegacyView() {
      return this.viewSessionsShown.some((r) => r.recordType !== "session");
    },
    tabLabels() {
      return [
        `${this.$t("dsdcoursesummary")} (${this.courseSummary.length})`,
        `${this.$t("dsdviewsessions")} (${this.viewSessionsShown.length})`,
        `${this.$t("dsdloginsessions")} (${this.loginSessions.length})`,
      ];
    },
  },
  mounted() {
    this.getCourses();
    this.getUsers();
    this.searchReport();
  },
  methods: {
    col(key, value) {
      return { text: this.$t(key), value: value, align: "left" };
    },
    dateCol(key, value, sortable) {
      const c = {
        text: this.$t(key),
        value: value,
        align: "left",
        class: "text-no-wrap",
        cellClass: "text-no-wrap",
      };
      if (sortable === false) c.sortable = false;
      return c;
    },
    dash(v) {
      return v == null || v === "" ? "-" : v;
    },
    fmt2(v) {
      return v == null || v === "" ? "-" : Number(v).toFixed(2);
    },
    fmtCount(n) {
      return Number(n || 0).toLocaleString("en-US");
    },
    reasonText(r) {
      const key = REASON_KEYS[r];
      return key ? this.$t(key) : null;
    },
    recordTypeText(t) {
      if (t === "legacy") return this.$t("dsdlegacyshort");
      if (t === "legacyCumulative") return this.$t("dsdlegacycumulative");
      return null;
    },
    platformText(p) {
      if (p == null || p === "") return null;
      if (Number(p) === 3) return this.$t("dsdplatformweb");
      if (Number(p) === 2) return this.$t("dsdplatformmobile");
      return String(p);
    },
    summaryNoteText(item) {
      return item.hasLegacyRows === true ? this.$t("dsdhaslegacy") : null;
    },
    videoProgressText(item) {
      if (!item.videoTotalCount) return "-"; // ไม่มีวิดีโอ active (เช่น คอร์สถูกลบ)
      return `${item.videoCompletedCount || 0}/${item.videoTotalCount}`;
    },
    showDetail(item) {
      this.detailFilter = {
        userID: item.userID,
        assignmentCourseID: item.assignmentCourseID,
        fullName: item.fullName,
        courseName: item.courseName,
      };
      this.pager.view.page = 1;
      this.tab = 1;
    },
    clearDetailFilter() {
      this.detailFilter = null;
      this.pager.view.page = 1;
    },
    loginNoteText(item) {
      return item.startType === 2 ? this.$t("dsdresumednote") : null;
    },
    withInactive(text, active) {
      if (text == null || text === "") return text;
      return active === false ? `${text} ${this.$t("dsdinactive")}` : text;
    },
    rangeDays(from, to) {
      return (
        moment(to, "YYYY-MM-DD").diff(moment(from, "YYYY-MM-DD"), "days") + 1
      );
    },
    onFromChange() {
      this.fromMenu = false;
      if (this.dateFrom && this.dateTo && this.dateFrom > this.dateTo) {
        this.dateTo = this.dateFrom;
      }
    },
    onToChange() {
      this.toMenu = false;
    },
    setItemsPerPage(name, n) {
      this.pager[name].itemsPerPage = n;
      this.pager[name].page = 1;
    },
    async getCourses() {
      try {
        const companyID = localStorage.getItem("companyID");
        const res = await this.$axios.get(
          `${this.web_url}Assignment/GetAssignmentCourseReportName?CompanyID=${companyID}`
        );
        if (res.data.status == 0) {
          this.courseItems = (res.data.data || []).slice().sort((a, b) =>
            (a.courseName || "")
              .toLowerCase()
              .localeCompare((b.courseName || "").toLowerCase())
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUsers() {
      try {
        const companyID = localStorage.getItem("companyID");
        const res = await this.$axios.get(
          `${this.web_url}EmployeeEXT/GetEmployeeExtAll?Id=${companyID}`
        );
        if (res.data.status == 0) {
          this.userItems = (res.data.data || []).slice().sort((a, b) =>
            (a.fullName || "")
              .toLowerCase()
              .localeCompare((b.fullName || "").toLowerCase())
          );
        }
      } catch (e) {
        console.error(e);
      }
    },
    clearAll() {
      this.dateFrom = moment().startOf("month").format("YYYY-MM-DD");
      this.dateTo = moment().format("YYYY-MM-DD");
      this.today = this.dateTo;
      this.selectedCourses = [];
      this.selectedUsers = [];
    },
    resetResults() {
      this.viewSessions = [];
      this.courseSummary = [];
      this.loginSessions = [];
      this.detailFilter = null;
      this.pager.view.page = 1;
      this.pager.summary.page = 1;
      this.pager.login.page = 1;
    },
    showError(type, key, params) {
      this.resetResults();
      this.lastQuery = null;
      this.alert = { type: type, text: this.$t(key, params) };
    },
    async searchReport() {
      if (this.loading) return;
      this.alert = null;
      const dateFrom = this.dateFrom;
      const dateTo = this.dateTo;
      if (!dateFrom || !dateTo || dateFrom > dateTo) {
        this.showError("warning", "dsdinvaliddaterange");
        return;
      }
      if (this.rangeDays(dateFrom, dateTo) > MAX_RANGE_DAYS) {
        this.showError("warning", "dsdrangetoolong");
        return;
      }
      const body = {
        companyID: localStorage.getItem("companyID"),
        requestUserID: parseInt(localStorage.getItem("UserID")),
        dateFrom: dateFrom,
        dateTo: dateTo,
        assignmentCourseIDs: [...this.selectedCourses],
        userIDs: [...this.selectedUsers],
      };
      const query = { dateFrom: dateFrom, dateTo: dateTo };
      this.loading = true;
      try {
        const res = await this.$axios.post(
          `${this.web_urlV7}Reports/GetDsdTrainingAttendanceReport`,
          body
        );
        const data = res.data.data || {};
        if (res.data.status == 0) {
          this.viewSessions = Object.freeze(data.viewSessions || []);
          this.courseSummary = Object.freeze(data.courseSummary || []);
          this.loginSessions = Object.freeze(data.loginSessions || []);
          this.detailFilter = null;
          this.pager.view.page = 1;
          this.pager.summary.page = 1;
          this.pager.login.page = 1;
          this.lastQuery = query;
        } else if (res.data.message === "TooManyRows") {
          this.showError("warning", "dsdtoomanyrows", {
            count: this.fmtCount(data.rowCount),
            max: this.fmtCount(data.maxRows),
          });
        } else if (res.data.message === "InvalidDateRange") {
          this.showError("warning", "dsdinvaliddaterange");
        } else if (res.data.message === "NoPermission") {
          this.showError("error", "dsdnopermission");
        } else {
          this.showError("error", "dsdloaderror");
        }
      } catch (e) {
        console.error(e);
        this.showError("error", "dsdloaderror");
      } finally {
        this.loading = false;
      }
    },
    addSheet(wb, name, cols, rows, meta) {
      const ws = wb.addWorksheet(name, {
        views: [{ state: "frozen", ySplit: 6 }],
      });
      ws.columns = cols.map((c) => ({ width: c.width }));

      const title = ws.getRow(1).getCell(1);
      title.value = this.$t("dsdtrainingattendance");
      title.font = { name: "Calibri", size: 14, bold: true };
      ws.getRow(2).getCell(1).value = `${this.$t("dsdcompany")}: ${
        meta.company
      }`;
      ws.getRow(3).getCell(1).value = `${this.$t("dsdperiod")}: ${
        meta.period
      } (${this.$t("dsdtimezonenote")})`;
      ws.getRow(4).getCell(1).value = `${this.$t("dsdexportedat")}: ${
        meta.exportedAt
      }`;
      if (meta.note) ws.getRow(5).getCell(1).value = meta.note;

      const header = ws.getRow(6);
      header.values = cols.map((c) => c.header);
      header.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "ff9900" },
          bgColor: { argb: "ff9900" },
        };
        cell.font = {
          name: "Calibri",
          size: 11,
          color: { argb: "000000" },
          bold: true,
        };
        cell.border = THIN_BORDER;
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });

      ws.addRows(rows.map((r) => cols.map((c) => c.get(r))));

      for (let i = 0; i < rows.length; i++) {
        const row = ws.getRow(7 + i);
        cols.forEach((c, j) => {
          const cell = row.getCell(j + 1);
          cell.border = THIN_BORDER;
          if (c.num) cell.numFmt = c.num;
        });
      }

      ws.autoFilter = {
        from: { row: 6, column: 1 },
        to: { row: 6, column: cols.length },
      };
    },
    async exportExcel() {
      if (!this.lastQuery || !this.hasAnyData) return;
      this.exporting = true;
      try {
        const t = (k) => this.$t(k);
        const q = this.lastQuery;
        let company = "";
        try {
          const u =
            JSON.parse(
              localStorage.getItem("vivek_authenticated_user_data") || "{}"
            ) || {};
          company = u.companyName || "";
        } catch (e) {
          company = "";
        }
        const meta = {
          company: company,
          period: `${toDMY(q.dateFrom)} - ${toDMY(q.dateTo)}`,
          exportedAt: moment().utcOffset(420).format("DD/MM/YYYY HH:mm:ss"),
        };

        const viewCols = [
          { header: t("employeeId"), get: (r) => nz(r.empID), width: 14 },
          {
            header: t("fullnamesm"),
            get: (r) => nz(this.withInactive(r.fullName, r.userActive)),
            width: 28,
          },
          {
            header: t("coursename"),
            get: (r) => nz(this.withInactive(r.courseName, r.courseActive)),
            width: 30,
          },
          {
            header: t("dsdvideoname"),
            get: (r) => nz(this.withInactive(r.videoName, r.videoActive)),
            width: 26,
          },
          { header: t("dsdwatchstart"), get: (r) => nz(r.watchStart), width: 20 },
          { header: t("dsdwatchend"), get: (r) => nz(r.watchEnd), width: 20 },
          {
            header: t("dsdwatchminutes"),
            get: (r) => num(r.watchMinutes),
            num: "0.00",
            width: 14,
          },
          {
            header: t("dsdwatchseconds"),
            get: (r) => num(r.watchSeconds),
            num: "0",
            width: 14,
          },
          { header: t("dsdloginat"), get: (r) => nz(r.loginAt), width: 20 },
          { header: t("dsdlogoutat"), get: (r) => nz(r.logoutAt), width: 20 },
          {
            header: t("dsdlogoutreason"),
            get: (r) => nz(this.reasonText(r.logoutReason)),
            width: 30,
          },
          {
            header: t("dsdnote"),
            get: (r) => nz(this.recordTypeText(r.recordType)),
            width: 36,
          },
        ];
        const summaryCols = [
          { header: t("employeeId"), get: (r) => nz(r.empID), width: 14 },
          { header: t("fullnamesm"), get: (r) => nz(r.fullName), width: 28 },
          { header: t("coursename"), get: (r) => nz(r.courseName), width: 30 },
          {
            header: t("dsdcoursehours"),
            get: (r) => nz(r.courseHHmm),
            width: 18,
          },
          {
            header: t("dsdvideoscompleted"),
            get: (r) => nz(this.videoProgressText(r)),
            width: 16,
          },
          {
            header: t("dsdtotalhoursinrange"),
            get: (r) => nz(r.countedHHmm),
            width: 22,
          },
          {
            header: t("dsdtotalhoursall"),
            get: (r) => nz(r.allTimeCountedHHmm),
            width: 22,
          },
          { header: t("dsdfirstwatch"), get: (r) => nz(r.firstWatch), width: 20 },
          { header: t("dsdlastwatch"), get: (r) => nz(r.lastWatch), width: 20 },
          {
            header: t("dsdnote"),
            get: (r) => nz(this.summaryNoteText(r)),
            width: 36,
          },
        ];
        const loginCols = [
          { header: t("employeeId"), get: (r) => nz(r.empID), width: 14 },
          { header: t("fullnamesm"), get: (r) => nz(r.fullName), width: 28 },
          {
            header: t("dsdplatform"),
            get: (r) => nz(this.platformText(r.platform)),
            width: 16,
          },
          { header: t("dsdloginat"), get: (r) => nz(r.loginAt), width: 20 },
          { header: t("dsdlogoutat"), get: (r) => nz(r.logoutAt), width: 20 },
          {
            header: t("dsddurationminutes"),
            get: (r) => num(r.durationMinutes),
            num: "0.00",
            width: 14,
          },
          {
            header: t("dsdlogoutreason"),
            get: (r) => nz(this.reasonText(r.logoutReason)),
            width: 30,
          },
          {
            header: t("dsdnote"),
            get: (r) => nz(this.loginNoteText(r)),
            width: 36,
          },
        ];

        const wb = new exceljs.Workbook();
        // TC-LMS-010/012: ชีตสรุปมาก่อน ตามลำดับแท็บ · ชีตรายละเอียดส่งออกทุกแถว (ไม่ใช้ตัวกรอง "ดูรายละเอียด")
        this.addSheet(wb, t("dsdsheetsummary"), summaryCols, this.courseSummary, {
          ...meta,
          note: `* ${t("dsdcountednote")}`,
        });
        this.addSheet(wb, t("dsdsheetview"), viewCols, this.viewSessions, meta);
        this.addSheet(
          wb,
          t("dsdsheetlogin"),
          loginCols,
          this.loginSessions,
          meta
        );

        const buf = await wb.xlsx.writeBuffer();
        saveAs(
          new Blob([buf], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
          }),
          `DsdTrainingAttendanceReport_${q.dateFrom.replace(
            /-/g,
            ""
          )}-${q.dateTo.replace(/-/g, "")}.xlsx`
        );
      } catch (e) {
        console.error(e);
        this.alert = { type: "error", text: this.$t("dsdloaderror") };
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 16px !important;
}
.filter-label {
  font-size: 16px;
  color: #424242;
  font-weight: bold;
  margin-top: 5px;
}
.v-autocomplete .v-chip {
  max-width: 140px;
}
@media (min-width: 960px) {
  .container {
    max-width: unset !important;
  }
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  font-size: 16px !important;
  color: #47484b !important;
  background-color: #e0e0e0 !important;
  opacity: 1;
}
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr
  > td {
  font-size: 15px !important;
  color: #47484b !important;
  vertical-align: top;
}
::v-deep .report-table thead th:first-child {
  border-radius: 8px 0 0 8px !important;
}
::v-deep .report-table thead th:last-child {
  border-radius: 0 8px 8px 0 !important;
}
.report-table tr:nth-child(even) {
  background: unset;
}
::v-deep .pagination .primary {
  background-color: #a6cc39 !important;
  color: #ffffff !important;
  opacity: 1;
}
::v-deep .v-pagination__navigation {
  border-radius: 6px !important;
  box-shadow: none !important;
  border: 1px solid #c0c0c0;
}
</style>
